var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewcloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9507 23.13C38.4848 21.5892 37.7144 20.2455 36.6932 19.1525C35.3853 17.6655 33.6473 16.6442 31.6944 16.1963C30.709 11.7171 27.9498 8.49213 24.0261 7.29171C19.7619 5.96588 14.8169 7.25588 11.7173 10.4988C8.99401 13.3475 8.09818 17.2713 9.15526 21.4459C5.57193 22.3238 3.79818 25.3159 3.60109 28.1646C3.58318 28.3617 3.58318 28.5409 3.58318 28.72C3.58318 32.0884 5.78693 35.8688 10.6961 36.2271H29.2936C31.8378 36.2271 34.2744 35.2775 36.1378 33.5755C39.0582 31.0134 40.1332 27.018 38.9507 23.13Z",
    fill: "#EEEEEE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewcloud);
export default __webpack_public_path__ + "static/media/previewcloud.855b6e931191b2ac1e940a9efd5e72f2.svg";
export { ForwardRef as ReactComponent };